<!--登录用户显示组件-->
<template lang="pug">
  //- .userInfo-wrapper.columns.is-horizontal
  //-   .column
  //-     .user-name(v-text="currentUser && currentUser.name")
  //-   .column
  //-     .logout-wrapper(@click="logOut")
  .user-wrapper(@mouseenter="onShowUserInfo()", @mouseleave="onHiddenUserInfo()")
    .head-portrait
      img(src="https://chedian-oss1.vchangyi.com/images/static/platform-management-icon.png", v-if="currentUser.role_name == 'SYSTEM_ADMIN'")
      img(src="https://chedian-oss1.vchangyi.com/images/static/enterprise-management-icon.png", v-if="currentUser.role_name == 'STORE_ADMIN'")
    .icon(:style='{transform: iconActiveStyle}')
    .user-info-box(v-if="isShowUserInfo",@mouseenter="onShowUserInfo()",  @mouseleave="onHiddenUserInfo()")
      .user-data
        p(v-text="currentUser.name")
        p(v-text="role_name[currentUser.role_name]")
      .user-desc
        .user-item
          el-tooltip(v-if="current_store.is_chain == 1", effect="dark", :content="current_store.enterprise.name", placement="bottom", popper-class="aaa")
            .store-type 连锁
          p(@mouseenter="onShowStoresList()", @mouseleave="onHiddenStoresList()",v-if="current",v-text="current.store_name", :title="current.store_name")
          i
        .user-item(@click="onEidtPassword", v-if="currentUser.from !== 'BOSS'") 修改密码
      .user-item.log-out(@click.stop="logOut") 退出登录
    .stores-list(@mouseenter="onShowStoresList()", @mouseleave="onHiddenStoresList()", v-if="list.length > 0 && isShowUserInfo && isExpanded")
      .stores-item(v-for="item in list", :class="{'stores-active': current === item}", v-text="item.store_name", :title="item.store_name ", @click.stop="switchTo(item.store_id)")

</template>

<script>
import userMixin from '@/mixins/modules/user'
import MseeageApi from '../../mixins/modules/messageNotice'
import CenterApi from '../../mixins/modules/AppCenter'
import { mapGetters } from 'vuex'

const ROLE_NAME = {
  STORE_ADMIN: '店铺管理员',
  SYSTEM_ADMIN: '系统管理员',
}

export default {
  name: 'UserInfoTab',
  mixins: [userMixin, MseeageApi, CenterApi],
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      current_store: 'currentStore',
      list: 'stores',
      isSystemAdmin: 'isSystemAdmin',
    }),
    iconActiveStyle () {
      return this.isShowUserInfo ? 'rotate(180deg)' : 'rotate(0)'
    },
  },
  props: {
    reloading: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    list () {
      this.current = this.findStore()
    },
  },
  data () {
    return {
      // 是否显示用户详情信息
      isShowUserInfo: false,
      // 是否显示门店列表
      isExpanded: false,
      // 角色名称
      role_name: ROLE_NAME,
      // 当前门店信息
      current: null,
      // 是否在切换门店中
      isSwitching: false,
    }
  },
  created () {
    let _this = this
    let body = document.querySelector('body')
    body.addEventListener('click', (e) => {
      _this.onHiddenUserInfo()
    }, false)
  },
  mounted () {
    // 调用消息公告列表
    this.$store.dispatch('synchronizeOlist')
    // 获取未读消息总数
    this.$store.dispatch('synchronizeMsgCount')
    // 如果没有门店就在获取一次
    if (!this.list.length) {
      this.$store.dispatch('synchronizeStores')
      this.$store.dispatch('syncAuthorizeStatus')
    }
    this.current = this.findStore()
  },
  methods: {
    // 显示用户详情
    onShowUserInfo () {
      this.isShowUserInfo = true
      clearTimeout(this.userTiemout)
    },
    // 隐藏用户详情
    onHiddenUserInfo () {
      // eslint-disable-next-line no-return-assign
      this.userTiemout = setTimeout(() => {
        this.isShowUserInfo = false
        this.toggle(false)
      }, 300)
    },
    // 显示门店列表
    onShowStoresList () {
      this.isShowUserInfo = true
      this.toggle(true)
      clearTimeout(this.userTiemout)
      clearTimeout(this.storeTiemout)
    },
    // 隐藏门店列表
    onHiddenStoresList () {
      this.storeTiemout = setTimeout(() => this.toggle(false), 300)
    },
    // 过滤返回当前门店信息
    findStore (currentUserId = this.currentUser.store_id) {
      return this.list.find(candidate => candidate.store_id === currentUserId)
    },
    // 修改密码
    onEidtPassword () {
      this.$router.replace({
        name: 'passWordSetting',
      })
    },
    // 切换门店
    async switchTo (store) {
      // console.log(store)
      if (this.current.store_id === store) {
        return false
      }
      if (!this.isSwitching) {
        const origin = this.current
        this.toggle(false)
        this.isSwitching = true
        this.current = store
        try {
          await this.switchStore(store)
          // this.$router.replace({
          //   name: 'WorkBenchOverview',
          // })
          // this.reloading && this.$router.push({
          //   name: 'writeOffAllList',
          // })
          if (this.reloading) {
            window.location.href = window.location.origin
          }
          // setTimeout(() => {
          //   this.reloading && this.$router.push({
          //     name: 'writeOffAllList',
          //   })
          // }, 300)
        } catch (err) {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '切换门店失败',
            content: `服务异常，请稍后再试（${err.response ? err.response.status : err}${err.result && err.result.code ? ' ' + err.result.code : ''}）`,
          })
          this.current = origin
        }
        this.isSwitching = false
        this.$emit('switched')
      }
    },
    toggle (state) {
      if (this.isSystemAdmin) {
        this.isExpanded = state
        if (this.isExpanded) {
          this.$hub.$emit(this.$hub.events.collapseDataPickers, this)
        }
      }
    },
    // 退出登录
    async logOut () {
      try {
        const {response, result} = await this.logout()
        if (response.status === 200) {
          this.$store.dispatch('clearUser')
          this.$store.dispatch('synchronizeClearMsg')   // 关闭消息组件
          sessionStorage.removeItem('closeKey')
          sessionStorage.removeItem('is_show_tip')
          sessionStorage.removeItem('is_show_open_store')
          if (this.$notify) {
            this.$notify.closeAll()
          }
          window.location.href = window.location.origin
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '登出失败',
            content: `服务异常，请稍后再试（${response.status}${result && result.code ? ' ' + result.code : ''}）`,
          })
        }
      } catch ({err}) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '登出失败',
          content: `服务异常，请稍后再试（${err.response ? err.response.status : err}${err.result && err.result.code ? ' ' + err.result.code : ''}）`,
        })
      }
    },
  },
}
</script>

<style scoped>
.user-wrapper{
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
}
.user-wrapper > .head-portrait{
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 10px;
}

.user-wrapper > .head-portrait > img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.icon{
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 7px 7px 0 7px;
  border-color: #9b9d9f transparent transparent transparent;
}
.user-info-box{
  position:absolute;
  min-width: 220px;
  background-color: #ffffff;
  top: 56px;
  right:  0;
  z-index: 100;
  box-shadow: 1px 2px 7px rgba(0,0,0,.2);
}

.user-info-box > .user-data{
  padding: 15px 20px;
  border-bottom: 1px solid #f5f5f5;
  background-color: #ffc723;
  position: relative;
}

.user-info-box > .user-data::before{
  content: '';
  position: absolute;
  top: -10px;
  right:  31px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 8px 10px 8px;
  border-color: transparent transparent #ffc723 transparent;
}

.user-info-box > .user-data > p:first-child{
  font-size: 16px;
  margin-bottom: 6px;
  color: #333;
}

.user-info-box > .user-data > p:last-child{
  font-size: 14px;
  color: #9b9d9f;
}

.log-out{
  border-top: 1px solid #f5f5f5;
}

.user-info-box .user-item {
  padding: 20px 15px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #666;
  font-size: 14px;
  cursor: pointer;
}

.user-info-box .user-item > p {
  width: 140px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}

.user-info-box .user-item > i {
  width: 8px;
  height: 8px;
  border-top: 2px solid currentColor;
  border-right: 2px solid currentColor;
  transform: rotate(45deg);
}

.user-info-box .user-item:hover{
  background-color: #f5f5f5;
}

.stores-list{
  position: absolute;
  width: 200px;
  height: 200px;
  top: 124px;
  right: 220px;
  background-color: #fff;
  box-shadow: 1px 2px 7px rgba(0,0,0,.2);
  z-index: 101;
  overflow-x: hidden;
  overflow-y: scroll;
}

.stores-item{
  padding: 10px 15px;
  padding-left: 30px;
  color: #666;
  font-size: 13px;
  width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
 }

.stores-item:hover{
  background-color: #f5f5f5;
}

.stores-active{
  color: #ffc723 !important;
}

.stores-active::before,
.stores-active::after{
  position: absolute;
  content: '';
  top: 0;
  bottom: 0;
  margin: auto;
}

.stores-active::before{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid;
  left: 10px;
}

.stores-active::after{
  width: 6px;
  height: 6px;
  background-color: #ffc723;
  border-radius: 50%;
  left: 14px;
}

.store-type{
  padding: 2px 3px;
  background-color: #ffc723;
  font-size: 12px;
  margin-right: 5px;
  color: #000;
}


/* // .user-name
//   font-size 15px
//   line-height 16px
//   padding 21px 2px 16px
//   color darker
// .logout-wrapper
//   width 16px
//   height 16px
//   margin 21px 0 19px 32px
//   cursor pointer
//   background getImage('menu/logout.svg') no-repeat center center
//   position relative
//   &::before
//     content ''
//     display block
//     position absolute
//     height 16px
//     background red
//     border-left 1px solid #f4f4f4
//     left -15px
//     top 50%
//     margin-top -8px
//     z-index 200
//   &:hover
//     background-image getImage('menu/logout-hover.svg') */
</style>



// WEBPACK FOOTER //
// src/components/generics/UserInfoTab.vue